import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlSegment, UrlTree, Route } from '@angular/router';

import { AuthenticationService } from '../../services/authentication.service';
import {Observable} from "rxjs";

@Injectable({ providedIn: 'root' })
export class AuthGuard  {
  /**
   *
   * @param {Router} _router
   * @param {AuthenticationService} _authenticationService
   */
  constructor(private _router: Router, private _authenticationService: AuthenticationService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this._authenticationService.currentUserValue;

    if (currentUser) {
      if (!this._authenticationService.isTokenNoValid()) {
        const requiredPermission = route.data['permisos'];
        if (!requiredPermission || this._authenticationService.tienePermiso(requiredPermission)) {
          return true;
        } else {
          this._router.navigate(['/potenciales-proyectos/listar']);
          return false;
        }

      } else {
        this._router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
      }
    }
    this._router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const currentUser = this._authenticationService.currentUserValue;
    if (currentUser) {
      const requiredPermission = route.data?.['permisos'];
      if (!requiredPermission || this._authenticationService.tienePermiso(requiredPermission)) {
        return true;
      }
    }else {
      this._router.navigate(['/potenciales-proyectos/listar']);
      return false;
    }
    this._router.navigate(['/login']);
    return false;
  }
}
